// extracted by mini-css-extract-plugin
export default {"partners-container":"Partners_partners-container__6RoGW","partners-logos":"Partners_partners-logos__-n8rK"};